import PropTypes from "prop-types";
import {Check} from "react-bootstrap-icons";
import {Checkbox} from "../inputs/index.js";
import {Dropdown} from "react-bootstrap";
import {Icons} from "../Icons.jsx";


const SelectColumns = (props) => {

    const {tableInstance} = props

    return (
        <>
            <Dropdown
                // drop={'start'}
                autoClose="inside"
                      className={props.className}
            >
                <Dropdown.Toggle className={`btn-secondary${props.toggleClassName ? ' ' + props.toggleClassName : ''}`}
                                 id="dropdown-autoclose-outside">
                    <Icons.table
                        size={18}
                        className={'me-1'}
                    />
                    Wybierz kolumny
                </Dropdown.Toggle>

                <Dropdown.Menu>

                    <div
                        className={'d-flex flex-column align-content-start p-3 text-start'}
                        style={{width: `300px`}}
                    >
                        <div className={'align-self-start'}>
                            <Checkbox
                                onChange={tableInstance.getToggleAllColumnsVisibilityHandler()}
                                value={tableInstance.getIsAllColumnsVisible()}
                                title={'Zaznacz / odznacz wszystkie'}
                                label={'Zaznacz / odznacz wszystkie'}
                                icon={<Check/>}
                            />
                        </div>

                        <hr/>

                        {tableInstance.getAllLeafColumns().map(column => (
                            <div key={column.id}
                                 className={'align-self-start'}
                            >
                                <Checkbox
                                    className={'fw-normal'}
                                    onChange={column.getToggleVisibilityHandler()}
                                    value={column.getIsVisible()}
                                    title={column.columnDef.header}
                                    label={column.columnDef.header}
                                    icon={<Check/>}
                                />
                            </div>
                        ))}
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        </>
    )
}


export default SelectColumns

SelectColumns.propTypes = {
    tableInstance: PropTypes.object.isRequired,
    className: PropTypes.string,
    toggleClassName: PropTypes.string,
}